import { render, staticRenderFns } from "./profileDataUpdate.vue?vue&type=template&id=2869c981&"
import script from "./profileDataUpdate.vue?vue&type=script&lang=js&"
export * from "./profileDataUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports